import type * as React from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

type ToastItemProps = {
    content: string;
    onButtonClick?: VoidFunction;
    buttonText?: string;
    minWidth?: string;
};

const ToastItem: React.FC<ToastItemProps> = ({ content, onButtonClick, buttonText, minWidth = "400px" }) => {
    return (
        <Flex
            gap="16px"
            justifyContent="space-between"
            alignItems="center"
            minWidth={minWidth}
        >
            <Text
                fontVariant="input2"
                color={colorsPalettes.carbon["0"]}
            >
                {content}
            </Text>
            {buttonText && onButtonClick ? (
                <Text
                    as="button"
                    fontVariant="button"
                    onClick={onButtonClick}
                    color={colorsPalettes.carbon["0"]}
                    flex="none"
                    border="none"
                    background="none"
                    padding="0"
                    cursor="pointer"
                >
                    {buttonText}
                </Text>
            ) : null}
        </Flex>
    );
};

export const renderErrorToast = (props: ToastItemProps) => (
    <Flex
        gap="8px"
        alignItems="center"
    >
        <SWReactIcons
            iconName="error-info"
            size="sm"
            iconColor={colorsPalettes.red[400]}
        />
        <ToastItem {...props} />
    </Flex>
);
